export class KeyboardInput {
  private keys = new Set<string>();
  private pendingEdgePresses = new Set<string>();

  constructor() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
  }

  private onKeyDown = (e: KeyboardEvent) => {
    if (!this.keys.has(e.code)) {
      this.pendingEdgePresses.add(e.code);
    }
    this.keys.add(e.code);
  };

  private onKeyUp = (e: KeyboardEvent) => {
    this.keys.delete(e.code);
  };

  isPressed(code: string): boolean {
    return this.keys.has(code);
  }

  // Returns true exactly once per physical key-press cycle.
  consumeEdgePress(code: string): boolean {
    if (this.pendingEdgePresses.has(code)) {
      this.pendingEdgePresses.delete(code);
      return true;
    }
    return false;
  }

  getMoveX(): number {
    let x = 0;
    if (this.isPressed('KeyA') || this.isPressed('ArrowLeft')) x -= 1;
    if (this.isPressed('KeyD') || this.isPressed('ArrowRight')) x += 1;
    return x;
  }

  getMoveZ(): number {
    let z = 0;
    if (this.isPressed('KeyW') || this.isPressed('ArrowUp')) z -= 1;
    if (this.isPressed('KeyS') || this.isPressed('ArrowDown')) z += 1;
    return z;
  }

  isJump(): boolean {
    return this.isPressed('Space');
  }

  isRun(): boolean {
    return this.isPressed('ShiftLeft') || this.isPressed('ShiftRight');
  }

  dispose() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
  }
}
